import { render, staticRenderFns } from "./RetainersListItem.vue?vue&type=template&id=521d2e1d&"
import script from "./RetainersListItem.vue?vue&type=script&lang=js&"
export * from "./RetainersListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports